// id of the single <main> landmark rendered by AppLayout (App.js). The skip link
// targets it and useRouteAnnouncer focuses it as the fallback when a page has no <h1>.
export const MAIN_CONTENT_ID = 'main-content';

// Marks a wrapper in <main> that holds persistent chrome (the trial / grace-period banners),
// not page content. useRouteAnnouncer does not count anything inside it as "the page has
// rendered", or a banner would make an empty redirecting page look finished.
export const ROUTE_CHROME_ATTRIBUTE = 'data-route-chrome';
